

export default function Learn() {
  return (
    <div className="py-20 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
            Stay Informed
          </div>

          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            Resources & Learning Center
          </h1>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Expand your cybersecurity knowledge with our
            comprehensive collection of guides, whitepapers,
            case studies, and certification resources.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Resource Categories */}
          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              GRC
            </h3>

            <p className="text-gray-600 mb-4">
              Essential guides for governance, risk, and
              compliance management.
            </p>

            <span className="text-blue-600 text-sm">
              Coming Soon
            </span>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Risk
            </h3>

            <p className="text-gray-600 mb-4">
              Risk assessment methodologies and mitigation
              strategies.
            </p>

            <span className="text-blue-600 text-sm">
              Coming Soon
            </span>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              IAM
            </h3>

            <p className="text-gray-600 mb-4">
              Best practices for identity and access management.
            </p>

            <span className="text-blue-600 text-sm">
              Coming Soon
            </span>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Compliance
            </h3>

            <p className="text-gray-600 mb-4">
              Learn how to automate your compliance processes
              with BOSSS.
            </p>

            <span className="text-blue-600 text-sm">
              Coming Soon
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
